import { useState } from 'react';
import { Share2, Link, Check } from 'lucide-react';
import { toast } from 'sonner';

const PLATFORMS = [
  { id: 'twitter', label: 'X / Twitter', color: '#000000', getUrl: (url, text) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}` },
  { id: 'facebook', label: 'Facebook', color: '#1877F2', getUrl: (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}` },
  { id: 'whatsapp', label: 'WhatsApp', color: '#25D366', getUrl: (url, text) => `https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}` },
];

export function ShareButtons({ url, title, type = 'track' }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareText = type === 'track' ? `Check out "${title}"` : type === 'merch' ? `Check out this merch: ${title}` : `Listen to "${title}"`;
  const shareUrl = url || window.location.href;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success('Link copied!');
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error('Failed to copy'); }
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text: shareText, url: shareUrl });
      } catch {}
    } else {
      setOpen(!open);
    }
  };

  return (
    <div className="relative inline-flex">
      <button onClick={handleNativeShare}
        className="flex items-center gap-1 px-2 py-1 text-[#A3A3A3] hover:text-[#DAA520] transition-colors text-xs"
        data-testid={`share-btn-${type}`}>
        <Share2 className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Share</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute bottom-full right-0 mb-2 bg-[#141414] border border-[#262626] rounded-lg shadow-2xl z-50 p-2 min-w-[160px]" data-testid="share-menu">
            {PLATFORMS.map(p => (
              <a key={p.id} href={p.getUrl(shareUrl, shareText)} target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-[#262626] rounded transition-colors"
                data-testid={`share-${p.id}`}>
                <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
                {p.label}
              </a>
            ))}
            <button onClick={copyLink}
              className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-[#262626] rounded transition-colors w-full text-left"
              data-testid="share-copy-link">
              {copied ? <Check className="w-3.5 h-3.5 text-[#1DB954]" /> : <Link className="w-3.5 h-3.5" />}
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
